import { categories, mainSiteUrl } from "@/mocks/siteData";

export default function CategoryButtons() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-primary-100/70 text-primary-700 text-xs font-medium rounded-full mb-4">
            Shop by Category
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Browse Product Categories
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Explore all product categories available through BaseTao. Click any category to start shopping directly.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-background-100 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-foreground-600 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <span
                className="text-sm font-medium text-foreground-700 text-center group-hover:text-primary-700 transition-colors leading-snug"
                dangerouslySetInnerHTML={{ __html: cat.name }}
              ></span>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Browse All Categories on BaseTao
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}